import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/imgs/nftv1.png'


const _withScopeId = n => (_pushScopeId("data-v-590d0ae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "digital-ownership",
  class: "section"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "section-title" }, "Digital Ownership", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "emphasis" }, "DATA == STORAGE", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "emphasis" }, "Not Your Keys,", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "emphasis" }, "Not Your Crypto", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "nftv1-example",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Description = _resolveComponent("Description")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Description, {
      text: _ctx.desc1.text,
      image: _ctx.desc1.image,
      position: _ctx.desc1.position
    }, null, 8, ["text", "image", "position"]),
    _hoisted_3,
    _createVNode(_component_Description, {
      text: _ctx.desc2.text,
      image: _ctx.desc2.image,
      position: _ctx.desc2.position
    }, null, 8, ["text", "image", "position"]),
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
  ]))
}